import React, { useState } from 'react';
import './ListenSpelling.css';

const words = [
  "apple", "banana", "cat", "dog", "elephant", "fish", "goat", "hat", "ice", "jacket","go","come","wait","have","has","want","give","say",
  "bat","ball","car","donkey","kite","good","bad","sit", "stand","walk","run","man","woman","child","infant","kid","shirt","pant","dress","learn",
  "other","another","look",
  // ... add more words to reach 200
];

const ListenSpelling = () => {
  const [currentWord, setCurrentWord] = useState("");
  const [voice, setVoice] = useState("female");
  const [speed, setSpeed] = useState(1);

  const handleWordClick = (word) => {
    setCurrentWord(word);
    spellWord(word);
  };

  const spellWord = (word) => {
    const utterance = new SpeechSynthesisUtterance(`The word is ${word}. Let's spell it.`);
    const voices = window.speechSynthesis.getVoices();
    utterance.voice = voices.find((v) => (voice === "male" ? v.name.includes("male") : v.name.includes("female")));
    utterance.rate = speed;
    window.speechSynthesis.speak(utterance);

    word.split("").forEach((letter, index) => {
      const letterUtterance = new SpeechSynthesisUtterance(letter);
      letterUtterance.voice = utterance.voice;
      letterUtterance.rate = speed;
      letterUtterance.lang = utterance.lang;
      window.speechSynthesis.speak(letterUtterance);
    });
  };

  return (
    <div className="AppLS">
      <h1>Learn Basic English Spellings</h1>
      <div className="controls">
        <label>
          Voice:
          <select value={voice} onChange={(e) => setVoice(e.target.value)}>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </label>
        <label>
          Speed:
          <input type="number" value={speed} onChange={(e) => setSpeed(e.target.value)} step="0.1" min="0.5" max="2" />
        </label>
      </div>
      <div className="word-list">
        {words.map((word, index) => (
          <button key={index} onClick={() => handleWordClick(word)}>
            {word}
          </button>
        ))}
      </div>
      <div className="current-word">
        {currentWord && <p>Current Word: {currentWord}</p>}
      </div>
    </div>
  );
};

export default ListenSpelling;
